export default __webpack_public_path__ + "static/media/achievements_page_framed.76007422.png";